import api from './axios';

const BASE = '/secure-uploads';

export const listUploadLinks = () =>
  api.get(`${BASE}/links/`);

export const listUploadBatches = () =>
  api.get(`${BASE}/batches/`);

export const createUploadLink = (payload) =>
  api.post(`${BASE}/links/`, payload);

export const revokeUploadLink = (token) =>
  api.patch(`${BASE}/links/${token}/revoke/`);
